import '@fortawesome/free-regular-svg-icons';
import '../assets/styles/Expertise.scss';

const labelsFirstFrameworks = ["Spring", "SpringBoot", "Django", "Flask", "FastAPI", ".Net Framework (6,8)", "ASP .NET Core", "Node.js", "React", "React Native", "Next.js"];
const labelsFirstLanguages = ["Java", "Python", "C#", "TypeScript", "JavaScript", "Go", "C/C++"];
const labelsFirstDatabases = ["SQL", "PostgreSQL", "MySQL", "AWS Aurora", "DynamoDB", "MongoDB"];
const labelsFirstCloud = ["AWS (EC2, S3, SQS, Lambda)", "Azure (Pipelines, CI/CD",];
const labelsFirstTools = ["AWS EC2", "AWS S3", "AWS SQS", "AWS Lambda", "AWS VPC", "Redis", "Docker", "Kubernetes", "GitHub", "Jira", "Postman"];
const labelsFirstConcepts = ["REST", "GraphQL", "Web Services", "Web Hooks", "Multithreading", "Concurrency", , "OOP", "TDD", "CI/CD", "DevOps", "Agile", "Containerization", "Orchestrations", "Design Patterns", "Networking", "Secure Coding (JWT, OAuth)", "State Management (Redux/State API)"];
const labelsSecond = ["Written & Vrbal Communication", "Problem Solving", "Analytical Thinking", "Rational", "Leadership", "Time Management", "Collaboration", "Team Player"];

function Expertise() {
    return (
        <div className="container" id="skills">
            <div className="skills-container">
                <h1>Skills</h1>
                <div
                    className="skills-grid"
                    style={{
                        display: "flex",
                        flexWrap: "wrap",
                        justifyContent: "center"
                    }}
                >
                    <div
                        style={{
                            margin: "4px",
                            // padding: "6px 12px",
                            borderRadius: "16px",
                            backgroundColor: "#f0f0f0",
                            color: "#333",
                            display: "flex",
                            flexDirection: "column",
                            border: "1px solid #ccc",
                            width: "100%",
                            maxWidth: "1200px"
                        }}
                        className="skill"
                    >
                        <h3 style={{
                            borderBottom: "4px solid #5000ca",
                            paddingBottom: "10px",
                            display: "inline-block"
                        }}>Technical Skills</h3>
                        <div
                            style={{
                                display: "flex",
                                flexWrap: "wrap",
                                justifyContent: "space-around"
                            }}
                        >
                            {[{ title: "Languages", data: labelsFirstLanguages },
                            { title: "Frameworks", data: labelsFirstFrameworks },
                            { title: "Databases", data: labelsFirstDatabases },
                            { title: "Cloud", data: labelsFirstCloud },
                            { title: "Tools", data: labelsFirstTools },
                            { title: "Concepts", data: labelsFirstConcepts },].map((section) => (
                                <div key={section.title}
                                    style={{
                                        margin: "2rem",
                                        minWidth: "200px",
                                        flex: "1 1 1 1",
                                    }}
                                >
                                    <h4>{section.title}</h4>
                                    <div
                                        style={{
                                            padding: "1rem"
                                        }}
                                        className="flex-chips"
                                    >
                                        {section.data.map((elem) => (
                                            <div
                                                key={elem}
                                                style={{
                                                    display: "flex",
                                                    alignItems: "center",
                                                    color: "#333",
                                                    fontSize: "14px",
                                                    fontWeight: "500",
                                                    marginBottom: "8px"
                                                }}
                                            >
                                                <span
                                                    style={{
                                                        marginRight: "6px",
                                                        fontSize: "18px",
                                                        color: "#5000ca"
                                                    }}
                                                >•</span>
                                                <h3 style={{ margin: 0 }}>{elem}</h3>
                                            </div>
                                        ))}
                                    </div>
                                </div>
                            ))}
                        </div>
                    </div>

                    <div
                        style={{
                            margin: "4px",
                            padding: "6px 12px",
                            borderRadius: "16px",
                            backgroundColor: "#f0f0f0",
                            color: "#333",
                            display: "flex",
                            flexDirection: "column",
                            border: "1px solid #ccc",
                            width: "100%",
                            maxWidth: "1200px"
                        }}
                        className="skill"
                    >
                        <h3 style={{
                            borderBottom: "4px solid #5000ca",
                            paddingBottom: "10px",
                            display: "inline-block"
                        }}>Soft Skills</h3>
                        <div
                            style={{
                                padding: "1rem",
                                display: "flex",
                                flexWrap: "wrap",
                                justifyContent: "center"
                            }}
                            className="flex-chips"
                        >
                            {labelsSecond.map((elem) => (
                                <div
                                    key={elem}
                                    style={{
                                        display: "flex",
                                        alignItems: "center",
                                        color: "#333",
                                        fontSize: "14px",
                                        fontWeight: "500",
                                        margin: "8px"
                                    }}
                                >
                                    <span
                                        style={{
                                            marginRight: "6px",
                                            fontSize: "18px",
                                            color: "#5000ca"
                                        }}
                                    >•</span>
                                    <h3 style={{ margin: 0 }}>{elem}</h3>
                                </div>
                            ))}
                        </div>
                    </div>
                </div>
            </div>

            {/* Responsive CSS */}
            <style>
                {`
                    @media (max-width: 768px) {
                        .skills-grid {
                            flex-direction: column;
                            align-items: center;
                        }
                        .skill {
                            width: 90%;
                        }
                        .flex-chips {
                            display: flex;
                            flex-wrap: wrap;
                            justify-content: center;
                        }
                    }
                `}
            </style>
        </div>
    );
}

export default Expertise;
